import React from "react";
import Select from "./Select";
import { COUNTRIES } from "../../constants";

const CountrySelect = props => (
  <Select {...props} options={COUNTRIES} valueKey="code" labelKey="name" />
);

export default CountrySelect;



// WEBPACK FOOTER //
// ./src/components/forms/CountrySelect.js